// src/carousel.tsx
import { Box as Box3, useMultiStyleConfig as useMultiStyleConfig2 } from "@chakra-ui/react";
import { useTheme } from "@spoonflower/cms-chakra-ui-theme";
import { useEffect, useState } from "react";

// src/components/progress/progress.tsx
import {
  Button,
  HStack,
  Progress,
  Text,
  useMultiStyleConfig
} from "@chakra-ui/react";
import { useIntl } from "react-intl";

// src/components/carousel-left-arrow.tsx
import { Icon } from "@chakra-ui/react";
import { jsx } from "react/jsx-runtime";
var CarouselLeftArrow = (_, props) => /* @__PURE__ */ jsx(Icon, { boxSize: "100%", viewBox: "0 0 28 13", fill: "#939A9D", ...props, children: /* @__PURE__ */ jsx("path", { d: "M1.96099 5.88463L27.3862 5.88463C27.5683 5.88463 27.7161 5.94324 27.8297 6.06046C27.9432 6.17768 28 6.33028 28 6.51826C28 6.70624 27.9432 6.85886 27.8297 6.97611C27.7161 7.09333 27.5683 7.15194 27.3862 7.15194L1.92109 7.15194L6.08854 11.4544C6.19903 11.5685 6.25427 11.7058 6.25427 11.8663C6.25427 12.0269 6.19597 12.1673 6.07937 12.2877C5.94229 12.4292 5.796 12.5 5.64049 12.5C5.485 12.5 5.33872 12.4292 5.20164 12.2877L0.359055 7.31986C0.246525 7.20368 0.163662 7.07695 0.11047 6.93966C0.0572758 6.80236 0.0204544 6.6619 1.90735e-06 6.51826C1.90735e-06 6.35351 0.0317059 6.20778 0.0951118 6.08106C0.158545 5.95431 0.246525 5.83286 0.359055 5.71671L5.20164 0.685462C5.34487 0.558714 5.48757 0.496932 5.62976 0.500117C5.77194 0.503275 5.91157 0.575615 6.04865 0.717135C6.18573 0.858657 6.25427 1.01126 6.25427 1.17494C6.25427 1.33864 6.1888 1.48809 6.05787 1.62327L1.96099 5.88463Z" }) });

// src/components/carousel-right-arrow.tsx
import { Icon as Icon2 } from "@chakra-ui/react";
import { jsx as jsx2 } from "react/jsx-runtime";
var CarouselRightArrow = (_, props) => /* @__PURE__ */ jsx2(Icon2, { boxSize: "100%", viewBox: "0 0 28 13", fill: "#939A9D", ...props, children: /* @__PURE__ */ jsx2("path", { d: "M26.039 7.11537H0.613781C0.431675 7.11537 0.283851 7.05676 0.170311 6.93954C0.0567702 6.82232 0 6.66972 0 6.48174C0 6.29376 0.0567702 6.14114 0.170311 6.02389C0.283851 5.90667 0.431675 5.84806 0.613781 5.84806H26.0789L21.9115 1.54555C21.801 1.43149 21.7457 1.2942 21.7457 1.13367C21.7457 0.973124 21.804 0.832659 21.9206 0.712281C22.0577 0.57076 22.204 0.5 22.3595 0.5C22.515 0.5 22.6613 0.57076 22.7984 0.712281L27.6409 5.68014C27.7535 5.79632 27.8363 5.92305 27.8895 6.06034C27.9427 6.19764 27.9795 6.3381 28 6.48174C28 6.64649 27.9683 6.79222 27.9049 6.91894C27.8415 7.04569 27.7535 7.16714 27.6409 7.28329L22.7984 12.3145C22.6551 12.4413 22.5124 12.5031 22.3702 12.4999C22.2281 12.4967 22.0884 12.4244 21.9514 12.2829C21.8143 12.1413 21.7457 11.9887 21.7457 11.8251C21.7457 11.6614 21.8112 11.5119 21.9421 11.3767L26.039 7.11537Z" }) });

// src/components/step.tsx
import { Box } from "@chakra-ui/react";
import { jsx as jsx3 } from "react/jsx-runtime";
var Step = (props) => {
  const { isActive, ...boxProps } = props;
  return /* @__PURE__ */ jsx3(
    Box,
    {
      flex: "1",
      h: "0.5",
      bg: isActive ? "gray.900" : "gray.200",
      borderRadius: "base",
      transition: "background 0.2s",
      ...boxProps
    }
  );
};

// src/components/progress/progress.tsx
import { Fragment, jsx as jsx4, jsxs } from "react/jsx-runtime";
var CarouselProgress = ({
  handleDecrementClick,
  handleIncrementClick,
  setActiveItem,
  activeItem,
  itemsLength,
  percentage,
  constraint,
  progressStyle = "percentage" /* Percentage */,
  sliderAppearance = "Light Mode"
}) => {
  const intl = useIntl();
  const styles = useMultiStyleConfig("Progress", {
    sliderAppearance
  });
  activeItem = activeItem ?? 0;
  switch (progressStyle) {
    case "percentage" /* Percentage */:
      return /* @__PURE__ */ jsxs(HStack, { justify: "center", sx: styles.percentageContainer, children: [
        /* @__PURE__ */ jsx4(
          Button,
          {
            "aria-label": intl.formatMessage({ id: "action.scroll.left" }) ?? "Scroll Left",
            onClick: handleDecrementClick,
            variant: "ghost-primary",
            isActive: activeItem !== 0,
            paddingLeft: { base: 0, xs: 4 },
            sx: styles.iconButton,
            children: /* @__PURE__ */ jsx4(CarouselLeftArrow, { boxSize: { base: 3, md: 6 } })
          }
        ),
        /* @__PURE__ */ jsx4(
          Progress,
          {
            role: "progressbar",
            "aria-label": intl.formatMessage({ id: "carousel.progress.ariaLabel" }) ?? "Progress Bar",
            value: percentage,
            sx: styles.progressBar
          }
        ),
        /* @__PURE__ */ jsx4(
          Button,
          {
            "aria-label": intl.formatMessage({ id: "action.scroll.right" }) ?? "Scroll Right",
            onClick: handleIncrementClick,
            zIndex: 2,
            variant: "ghost-primary",
            isActive: activeItem < itemsLength - constraint,
            paddingRight: { base: 0, xs: 4 },
            sx: styles.iconButton,
            children: /* @__PURE__ */ jsx4(CarouselRightArrow, { boxSize: { base: 3, md: 6 } })
          }
        )
      ] });
    case "steps" /* Steps */:
      return /* @__PURE__ */ jsxs(Fragment, { children: [
        /* @__PURE__ */ jsxs(HStack, { sx: styles.stepsContainer, children: [
          /* @__PURE__ */ jsx4(HStack, { spacing: 3, children: [...Array(itemsLength)].map((_, id) => /* @__PURE__ */ jsx4(
            Step,
            {
              onClick: () => setActiveItem(id),
              isActive: activeItem === id,
              sx: styles.step
            },
            id
          )) }),
          /* @__PURE__ */ jsx4(Text, { sx: styles.text, children: `${activeItem + 1} / ${itemsLength}` })
        ] }),
        activeItem !== 0 && /* @__PURE__ */ jsx4(
          Button,
          {
            "aria-label": intl.formatMessage({ id: "action.scroll.left" }) ?? "Scroll Left",
            onClick: handleDecrementClick,
            variant: "ghost-primary",
            left: { base: 3.5, md: 0 },
            sx: styles.stepArrowButton,
            children: /* @__PURE__ */ jsx4(CarouselLeftArrow, { boxSize: { base: 5, md: 7 } })
          }
        ),
        activeItem < itemsLength - constraint && /* @__PURE__ */ jsx4(
          Button,
          {
            "aria-label": intl.formatMessage({ id: "action.scroll.right" }) ?? "Scroll Right",
            onClick: handleIncrementClick,
            variant: "ghost-primary",
            right: { base: 3.5, md: 0 },
            sx: styles.stepArrowButton,
            children: /* @__PURE__ */ jsx4(CarouselRightArrow, { boxSize: { base: 5, md: 7 } })
          }
        )
      ] });
  }
};
var progress_default = CarouselProgress;

// src/components/slide.tsx
import { Box as Box2 } from "@chakra-ui/react";
import { jsx as jsx5 } from "react/jsx-runtime";
var CarouselSlide = (props) => /* @__PURE__ */ jsx5(
  Box2,
  {
    className: "chakra-carousel__slide",
    minW: "100%",
    display: "flex",
    ...props
  }
);

// src/components/wrapper.tsx
import { Flex } from "@chakra-ui/react";
import { forwardRef } from "react";
import { jsx as jsx6 } from "react/jsx-runtime";
var CarouselWrapper = forwardRef(
  function CarouselWrapper2(props, ref) {
    return /* @__PURE__ */ jsx6(
      Flex,
      {
        ref,
        className: "chakra-carousel",
        overflow: "hidden",
        position: "relative",
        userSelect: "none",
        ...props
      }
    );
  }
);

// src/hooks/use-carousel.tsx
import { useKeenSlider } from "keen-slider/react";
var useCarousel = (options) => {
  const defaultOptions = { selector: ".chakra-carousel__slide" };
  return useKeenSlider({ ...defaultOptions, ...options });
};

// src/carousel.theme.tsx
import { extendTheme } from "@chakra-ui/react";
import { theme as theme2 } from "@spoonflower/cms-chakra-ui-theme";

// src/carousel.styles.ts
import { defineStyleConfig } from "@chakra-ui/styled-system";
var baseStyle = () => {
  return {
    keenSlider: {
      paddingLeft: 0
    },
    carousel: {
      display: "flex",
      scrollSnapType: "x mandatory"
    }
  };
};
var carouselStyles = defineStyleConfig({
  baseStyle
});
var carousel_styles_default = carouselStyles;

// src/components/progress/progress.styles.ts
import {
  defineStyleConfig as defineStyleConfig2
} from "@chakra-ui/styled-system";
import { theme } from "@spoonflower/cms-chakra-ui-theme";
var baseStyle2 = ({ sliderAppearance }) => {
  const isLightMode = sliderAppearance === "Light Mode";
  return {
    percentageContainer: {
      marginX: "auto",
      marginTop: { base: 5, md: 8 },
      gap: { base: 2, md: 4, lg: 6 },
      background: isLightMode ? theme.colors["warm-white"] : "gray.600",
      paddingBottom: 2
    },
    iconButton: {
      borderRadius: "sm",
      minWidth: 0,
      maxWidth: 16,
      "> svg": {
        width: { base: 5, xs: 7 },
        height: { base: 2, xs: 3 }
      },
      _active: {
        "> svg": isLightMode ? { fill: "gray.900" } : { fill: theme.colors["white"] },
        "@media (min-width: 320px)": {
          _hover: {
            "": isLightMode ? "" : { background: "white-opacity.900" },
            "> svg": isLightMode ? { fill: "primary.500" } : { fill: "gray.900" }
          }
        }
      }
    },
    progressBar: {
      alignSelf: "center",
      borderRadius: "base",
      background: isLightMode ? "gray.100" : "gray.300",
      flex: 1,
      height: { base: 0.5, xs: 1 },
      maxWidth: "304px",
      "> div": {
        backgroundColor: isLightMode ? "gray.600" : theme.colors["white"]
      }
    },
    stepsContainer: {
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      zIndex: 1,
      paddingTop: 6
    },
    step: {
      cursor: "pointer",
      minWidth: 7
    },
    text: {
      fontSize: "sm",
      marginTop: 2
    },
    stepArrowButton: {
      background: "white-opacity.900",
      borderRadius: "sm",
      _hover: {
        background: theme.colors["white"],
        "> svg": {
          fill: theme.colors["black"]
        }
      },
      minWidth: 0,
      maxWidth: 12,
      height: 12,
      display: { base: "none", sm: "flex" },
      position: "absolute",
      top: 0,
      bottom: 0,
      margin: "auto",
      zIndex: 1,
      transform: { base: "translate(0, 105%)", lg: "translate(0, 150%)" },
      padding: 2.5
    }
  };
};
var progressStyles = defineStyleConfig2({
  baseStyle: baseStyle2
});
var progress_styles_default = progressStyles;

// src/carousel.theme.tsx
var carouselExtendedTheme = extendTheme({
  ...theme2,
  components: {
    ...theme2.components,
    Progress: progress_styles_default,
    Carousel: carousel_styles_default
  }
});

// src/carousel.tsx
import { jsx as jsx7, jsxs as jsxs2 } from "react/jsx-runtime";
var Carousel = ({
  children,
  options,
  sliderAppearance,
  anchorId
}) => {
  const theme3 = useTheme();
  const defaultOptions = {
    itemsPerSlide: {
      lessThanSm: 1.2,
      betweenSmAndMd: 2.2,
      betweenMdAndLg: 3.2,
      greaterThanLg: 4.2
    },
    gap: {
      lessThanSm: 8,
      betweenSmAndMd: 8,
      betweenMdAndLg: 16,
      greaterThanLg: 24
    },
    progressStyle: "percentage" /* Percentage */
  };
  const { gap, progressStyle, itemsPerSlide } = {
    ...defaultOptions,
    ...options
  };
  const isSteps = progressStyle === "steps" /* Steps */;
  const [currentSlide, setCurrentSlide] = useState(0);
  const [perView, setPerView] = useState(itemsPerSlide.greaterThanLg);
  const showProgressBar = perView < children.length;
  const styles = useMultiStyleConfig2("Carousel", {
    gap,
    isSteps
  });
  const [ref, slider] = useCarousel({
    breakpoints: {
      [`(min-width: ${theme3.breakpoints.xs}`]: {
        slides: {
          perView: itemsPerSlide.lessThanSm,
          spacing: gap.lessThanSm
        }
      },
      [`(min-width: ${theme3.breakpoints.sm})`]: {
        slides: {
          perView: itemsPerSlide.betweenSmAndMd,
          spacing: gap.betweenSmAndMd
        }
      },
      [`(min-width: ${theme3.breakpoints.md})`]: {
        slides: {
          perView: itemsPerSlide.betweenMdAndLg,
          spacing: gap.betweenMdAndLg
        }
      },
      [`(min-width: ${theme3.breakpoints.lg})`]: {
        slides: {
          perView: itemsPerSlide.greaterThanLg,
          spacing: gap.greaterThanLg
        }
      }
    },
    slideChanged: (slider2) => setCurrentSlide(slider2.track.details.rel),
    slides: {
      perView: itemsPerSlide.lessThanSm
    }
  });
  const setActiveItem = (num) => {
    slider.current?.moveToIdx(num);
  };
  const isSm = () => window.matchMedia(`(max-width: ${theme3.breakpoints.sm})`).matches;
  const isBetweenSmAndMd = () => window.matchMedia(
    `(min-width: calc(${theme3.breakpoints.sm} + 0.0625rem)) and (max-width: ${theme3.breakpoints.md})`
  ).matches;
  const isBetweenMdAndLg = () => window.matchMedia(
    `(min-width: calc(${theme3.breakpoints.md} + 0.0625rem)) and (max-width: ${theme3.breakpoints.lg})`
  ).matches;
  const isLg = () => window.matchMedia(`(min-width: calc(${theme3.breakpoints.lg} + 0.0625rem))`).matches;
  const handleResize = () => {
    if (isSm()) {
      setPerView(itemsPerSlide.lessThanSm);
    } else if (isBetweenSmAndMd()) {
      setPerView(itemsPerSlide.betweenSmAndMd);
    } else if (isBetweenMdAndLg()) {
      setPerView(itemsPerSlide.betweenMdAndLg);
    } else if (isLg()) {
      setPerView(itemsPerSlide.greaterThanLg);
    }
  };
  useEffect(() => {
    handleResize();
    window.addEventListener("resize", handleResize);
  });
  useEffect(() => {
    slider.current?.update();
  }, [children.length]);
  return /* @__PURE__ */ jsxs2(Box3, { __css: styles.wrapper, ...anchorId ? { id: anchorId } : {}, children: [
    /* @__PURE__ */ jsx7(Box3, { className: "keen-slider", sx: styles.keenSlider, children: /* @__PURE__ */ jsx7(CarouselWrapper, { ref, sx: styles.carousel, children: children.map((item, index) => {
      return /* @__PURE__ */ jsx7(CarouselSlide, { children: item }, index);
    }) }) }),
    showProgressBar && /* @__PURE__ */ jsx7(
      progress_default,
      {
        handleDecrementClick: () => slider.current?.prev(),
        handleIncrementClick: () => slider.current?.next(),
        setActiveItem,
        progressStyle,
        constraint: perView,
        percentage: (currentSlide + perView) / children?.length * 100,
        itemsLength: children.length,
        activeItem: currentSlide,
        sliderAppearance
      }
    )
  ] });
};
export {
  Carousel,
  carouselExtendedTheme
};
